var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _circle2, _circle3, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoV = function SvgLogoV(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 877.88 595.097"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__a",
    x1: 166.333,
    x2: 199.87,
    y1: 363.641,
    y2: 363.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__a)",
    d: "M170.729 343.127h-.85a3.546 3.546 0 0 0-3.547 3.547v37.478l4.051-4.955 29.486-36.071h-29.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__b",
    x1: 166.333,
    x2: 240.435,
    y1: 400.571,
    y2: 400.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#da1c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__b)",
    d: "M195.728 394.658h-1.723a3.546 3.546 0 0 1-3.547-3.546c0-1.063.477-2.008 1.221-2.656l-21.295-9.257-4.051 4.955v34.244a3.55 3.55 0 0 0 3.547 3.546h65.5a5.053 5.053 0 1 0 0-10.105h-38.433a3.548 3.548 0 0 1 0-7.095l2.525.021h15.664a5.05 5.05 0 0 0 4.932-3.968l-14.117-6.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__c",
    x1: 170.384,
    x2: 244.276,
    y1: 365.792,
    y2: 365.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40bfb7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a79d"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__c)",
    d: "M191.679 388.456a3.5 3.5 0 0 1 2.326-.889l2.684.02h31.168a5.05 5.05 0 0 0 5.051-5.052 5.05 5.05 0 0 0-5.051-5.053h-31.168l-4.457.021a3.546 3.546 0 1 1 0-7.092h46.992a5.053 5.053 0 1 0 0-10.105h-42.476a3.547 3.547 0 0 1 0-7.093l4.029.021h27.365a5.052 5.052 0 1 0 0-10.106H199.87l-29.486 36.071z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__d",
    x1: 205.95,
    x2: 220.189,
    y1: 397.728,
    y2: 397.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40bfb7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a79d"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__d)",
    d: "M215.136 394.658h-9.186l14.117 6.14c.078-.351.121-.713.121-1.084a5.053 5.053 0 0 0-5.052-5.056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__e",
    x1: 631.847,
    x2: 671.384,
    y1: 374.847,
    y2: 414.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f15a29"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__e)",
    d: "M625.896 382.535c0 20.507 15.67 37.335 35.686 39.212l-21.963-69.078c-8.399 7.223-13.723 17.918-13.723 29.866"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__f",
    x1: 639.618,
    x2: 711.774,
    y1: 382.535,
    y2: 382.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#da1c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__f)",
    d: "M705.974 411.839H670.89a3.545 3.545 0 0 1-3.541-3.548 3.544 3.544 0 0 1 3.541-3.547l2.529.021h7.797a5.05 5.05 0 0 0 5.049-5.052 5.05 5.05 0 0 0-5.049-5.056H667.95a3.546 3.546 0 0 1 0-7.091l2.686.02h4.27a5.052 5.052 0 1 0 0-10.105h-4.27l-4.455.021a3.546 3.546 0 1 1 0-7.092h7.975a5.053 5.053 0 1 0 0-10.105h-3.461a3.547 3.547 0 0 1 0-7.093l4.031.021h32a5.05 5.05 0 0 0 5.049-5.051 5.05 5.05 0 0 0-5.049-5.055h-43.223c-.271 0-.529.037-.783.093-8.803.572-16.814 4.036-23.102 9.448l21.963 69.078c.379.037.756.078 1.139.102.252.058.512.095.783.095h42.471a5.053 5.053 0 0 0 0-10.104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__g",
    x1: 433.456,
    x2: 506.872,
    y1: 357.711,
    y2: 357.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__g)",
    d: "M465.974 360.305h-2.104c-1.957 0-3.549-1.588-3.549-3.547s1.592-3.546 3.549-3.546l4.029.021h33.924a5.05 5.05 0 0 0 5.049-5.051 5.05 5.05 0 0 0-5.049-5.055H437a3.545 3.545 0 0 0-3.545 3.547v25.62l49.084-11.368a5 5 0 0 0-2.428-.622z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__h",
    x1: 433.456,
    x2: 507.558,
    y1: 391.435,
    y2: 391.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#da1c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__h)",
    d: "M433.456 418.397a3.55 3.55 0 0 0 3.545 3.546h65.502a5.053 5.053 0 1 0 0-10.105h-38.435a3.546 3.546 0 0 1-3.545-3.548 3.545 3.545 0 0 1 3.545-3.547l2.525.021h7.139a5.055 5.055 0 1 0 0-10.108h-12.606a3.547 3.547 0 1 1 0-7.091l2.686.02h31.166a5.053 5.053 0 0 0 0-10.105h-31.166l-4.457.021a3.547 3.547 0 1 1 0-7.092h20.758a5.053 5.053 0 0 0 2.428-9.483l-49.084 11.368v46.103z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__i",
    x1: 567.402,
    x2: 606.021,
    y1: 345.887,
    y2: 384.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f15a29"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__i)",
    d: "M562.671 366.783a3.53 3.53 0 0 1 2.729-1.305 3.547 3.547 0 0 1 3.549 3.545v2.972l10.104 8.399v-6.853a3.546 3.546 0 1 1 7.094 0l-.021 4.03v8.702l10.105 8.398v-47.146l.002-.85a3.55 3.55 0 0 0-3.549-3.547h-33.297l-19.691 4.561z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__j",
    x1: 526.425,
    x2: 604.362,
    y1: 364.995,
    y2: 425.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40bfb7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a79d"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__j)",
    d: "M568.948 421.943a5.053 5.053 0 0 0 10.104 0v-41.549l-10.104-8.399z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__k",
    x1: 533.59,
    x2: 611.533,
    y1: 355.812,
    y2: 416.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40bfb7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a79d"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__k)",
    d: "M586.124 404.933a5.053 5.053 0 0 0 10.106 0v-10.262l-10.105-8.398z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__l",
    x1: 518.242,
    x2: 596.181,
    y1: 375.47,
    y2: 436.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40bfb7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a79d"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__l)",
    d: "M517.413 352.851v64.039a5.053 5.053 0 1 0 10.106 0v-43.152a3.547 3.547 0 0 1 3.547-3.546 3.544 3.544 0 0 1 3.545 3.546l-.021 2.525v21.91a5.055 5.055 0 0 0 10.108 0v-27.376a3.55 3.55 0 0 1 3.545-3.548 3.55 3.55 0 0 1 3.547 3.548l-.02 2.686v34.834a5.053 5.053 0 1 0 10.106 0v-34.834l-.021-4.459c0-.854.316-1.629.818-2.24l-22.977-19.095z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__m",
    x1: 517.413,
    x2: 539.694,
    y1: 347.989,
    y2: 347.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#da1c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__m)",
    d: "M534.206 343.127H520.96a3.546 3.546 0 0 0-3.547 3.547v6.176l22.281-5.162z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA1C5C",
    d: "m539.694 347.688 19.692-4.561h-25.18z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M611.604 422.514a5.05 5.05 0 0 0 5.051-5.052v-5.816l-10.104-8.398v14.215a5.053 5.053 0 0 0 5.053 5.051"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__n",
    x1: 611.604,
    x2: 611.604,
    y1: 351.683,
    y2: 411.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__n)",
    d: "M616.655 374.972v-27.363a5.05 5.05 0 0 0-5.053-5.052 5.05 5.05 0 0 0-5.051 5.052v55.637l10.104 8.398z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__o",
    x1: 334.894,
    x2: 380.771,
    y1: 365.656,
    y2: 365.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__o)",
    d: "M380.771 383.765v-2.328l-12.004-38.31h-26.035a5.05 5.05 0 0 0-5.051 5.052 5.05 5.05 0 0 0 5.051 5.054h15.406a3.545 3.545 0 0 1 3.547 3.545 3.55 3.55 0 0 1-3.547 3.548l-2.525-.021h-15.666a5.052 5.052 0 1 0 0 10.105h21.133a3.546 3.546 0 1 1 0 7.092l-2.686-.021h-12.137a5.054 5.054 0 0 0-5.055 5.053 5.054 5.054 0 0 0 5.055 5.052h12.137l4.459-.02a3.5 3.5 0 0 1 1.996.617l15.922-3.688z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__p",
    x1: 386.651,
    x2: 422.81,
    y1: 397.827,
    y2: 397.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40bfb7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a79d"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__p)",
    d: "M390.876 382.291v12.931a5.05 5.05 0 0 1-4.225 4.979l6.432 20.524c17.082-4.314 29.727-19.769 29.727-38.191 0-2.602-.254-5.144-.734-7.605l-31.199 7.227z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__q",
    x1: 368.767,
    x2: 422.075,
    y1: 362.642,
    y2: 362.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#da1c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__q)",
    d: "M385.987 343.221a3.6 3.6 0 0 0-.785-.093h-16.436l12.004 38.31V369.85a5.053 5.053 0 1 1 10.106 0v12.306l31.199-7.227c-3.381-17.298-18.09-30.539-36.088-31.708"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__r",
    x1: 352.491,
    x2: 396.833,
    y1: 390.22,
    y2: 434.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f15a29"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__r)",
    d: "M385.825 400.275a5.054 5.054 0 0 1-5.055-5.054v-10.725l-15.922 3.688a3.54 3.54 0 0 1 1.551 2.928 3.546 3.546 0 0 1-3.547 3.546h-15.846a5.054 5.054 0 1 0 0 10.108h11.33a3.547 3.547 0 0 1 0 7.093l-4.031-.02h-2.004a5.052 5.052 0 0 0 0 10.103h31.098v.002l.016-.002h.938l.85.002c.273 0 .531-.037.785-.095a39 39 0 0 0 7.096-1.123l-6.432-20.524a5 5 0 0 1-.827.073"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__s",
    x1: 249.712,
    x2: 328.528,
    y1: 380.403,
    y2: 380.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40bfb7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a79d"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__s)",
    d: "M289.12 342.788h-35.861a3.547 3.547 0 0 0-3.547 3.547v67.348l9.973 4.336q.131-.548.133-1.131V360.94a3.545 3.545 0 0 1 3.545-3.546 3.546 3.546 0 0 1 3.549 3.546l-.021 2.524v12.978a5.052 5.052 0 1 0 10.104 0v-3.001a3.548 3.548 0 0 1 7.094 0l-.02 2.686v5.965a5.053 5.053 0 1 0 10.106 0v-7.728l-.02-4.461a3.546 3.546 0 0 1 7.092 0v16.882a5.054 5.054 0 0 0 10.106 0v-3.975.573a3.545 3.545 0 1 1 7.09 0l-.018.386v15.169l10.105-2.341v-16.989c-1.334-20.556-18.515-36.82-39.41-36.82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__t",
    x1: 315.217,
    x2: 340.946,
    y1: 399.523,
    y2: 425.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f15a29"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__t)",
    d: "M318.423 416.872c0 2.793 2.262 5.054 5.053 5.054s5.053-2.261 5.053-5.054v-20.274l-10.105 2.341z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__u",
    x1: 249.712,
    x2: 259.685,
    y1: 417.812,
    y2: 417.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#da1c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__u)",
    d: "M249.712 416.888a5.05 5.05 0 0 0 9.973 1.131l-9.973-4.336z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__v",
    x1: 438.37,
    x2: 438.37,
    y1: 142.778,
    y2: 168.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 438.37,
    cy: 153.943,
    r: 11.336,
    fill: "url(#logo-v_svg__v)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__w",
    x1: 391.079,
    x2: 391.079,
    y1: 142.778,
    y2: 168.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.079,
    cy: 153.943,
    r: 4.412,
    fill: "url(#logo-v_svg__w)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__x",
    x1: 485.891,
    x2: 485.891,
    y1: 142.778,
    y2: 168.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 485.89,
    cy: 153.943,
    r: 4.412,
    fill: "url(#logo-v_svg__x)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__y",
    x1: 366.099,
    x2: 429.737,
    y1: 150.585,
    y2: 150.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__y)",
    d: "M414.938 153.943c0-9.901 6.129-18.36 14.799-21.811l-29.977-13.031h-.836c-18.131 0-32.826 14.697-32.826 32.826 0 13.512 8.168 25.108 19.832 30.141l30.555-19.743a23.4 23.4 0 0 1-1.547-8.382m-23.818 11.336c-6.262 0-11.336-5.077-11.336-11.335 0-6.262 5.074-11.336 11.336-11.336s11.336 5.075 11.336 11.336c0 6.258-5.074 11.335-11.336 11.335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__z",
    x1: 399.761,
    x2: 482.815,
    y1: 128.251,
    y2: 128.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40bfb7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a79d"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__z)",
    d: "M438.409 130.469a23.4 23.4 0 0 1 16.654 6.931l27.752-17.93a33 33 0 0 0-4.918-.368H399.76l29.977 13.031a23.3 23.3 0 0 1 8.672-1.664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__A",
    x1: 421.257,
    x2: 499.32,
    y1: 172.538,
    y2: 250.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#da1c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__A)",
    d: "M481.573 184.542c11.518-1.284 21.236-8.526 26-18.576l-12.535-5.449c-2.057 2.878-5.416 4.762-9.223 4.762-6.26 0-11.336-5.077-11.336-11.335q.002-1.164.227-2.264l-14.428-6.271a23.5 23.5 0 0 1 1.607 8.535c0 12.963-10.51 23.475-23.477 23.475-10.008 0-18.549-6.27-21.924-15.093l-30.555 19.743a32.6 32.6 0 0 0 10.359 2.568 3.545 3.545 0 0 1 2.609 3.414v52.921a5.066 5.066 0 0 0 10.131 0v-38.535a3.557 3.557 0 0 1 7.114 0l-.02 2.532v49.143a5.065 5.065 0 1 0 10.13 0v-54.623c0-1.964 1.592-3.559 3.555-3.559s3.555 1.595 3.555 3.559l-.02 2.692v65.433a5.066 5.066 0 1 0 10.13 0V202.18l-.02-4.472a3.556 3.556 0 0 1 7.112 0v47.115c0 2.799 2.268 5.066 5.066 5.066s5.066-2.267 5.066-5.066v-42.586a3.555 3.555 0 0 1 7.112 0l-.021 4.041v27.435a5.065 5.065 0 1 0 10.128 0v-45.607c0-1.965 1.926-3.459 3.559-3.555z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__B",
    x1: 478.253,
    x2: 518.369,
    y1: 134.622,
    y2: 174.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fbb040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f15a29"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__B)",
    d: "m482.815 119.47-27.752 17.93a23.5 23.5 0 0 1 5.215 8.008l14.428 6.271c1.051-5.175 5.625-9.073 11.109-9.073 6.262 0 11.338 5.075 11.338 11.336a11.27 11.27 0 0 1-2.115 6.574l12.535 5.449a32.7 32.7 0 0 0 3.148-14.039c.001-16.456-12.111-30.083-27.906-32.456"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__C",
    x1: 175.142,
    x2: 175.142,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__C)",
    d: "M168.88 449.357h2.762l2.779 7.021c.32.84.721 2.081.721 2.081h.039s.381-1.24.701-2.081l2.781-7.021h2.76l1.141 14.203h-2.561l-.6-7.942c-.061-.94-.021-2.2-.021-2.2h-.039s-.42 1.38-.76 2.2l-2.301 5.501h-2.262l-2.279-5.501c-.34-.82-.781-2.22-.781-2.22h-.039s.039 1.28-.02 2.22l-.602 7.942h-2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__D",
    x1: 191.991,
    x2: 191.991,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__D)",
    d: "M194.481 459.919h-4.98l-1.201 3.641h-2.66l5.002-14.203h2.699l5.002 14.203h-2.66zm-2.5-8.102s-.32 1.4-.6 2.201l-1.262 3.801h3.721l-1.26-3.801c-.26-.8-.561-2.201-.561-2.201z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__E",
    x1: 207.241,
    x2: 207.241,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__E)",
    d: "M201.86 449.357h4.58c1.541 0 2.24.12 2.861.4 1.42.64 2.32 2 2.32 3.88 0 1.701-.9 3.281-2.4 3.881v.04s.199.2.48.7l2.92 5.301h-2.881l-2.82-5.301h-2.48v5.301h-2.58zm4.901 6.662c1.381 0 2.24-.82 2.24-2.241 0-1.36-.58-2.2-2.6-2.2h-1.961v4.441z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__F",
    x1: 222.121,
    x2: 222.121,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__F)",
    d: "M216.72 449.357h2.58v5.781h1.84l3.342-5.781h2.801l-4.021 6.762v.04l4.262 7.401h-2.9l-3.482-6.201h-1.84v6.201h-2.58v-14.203z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__G",
    x1: 235.769,
    x2: 235.769,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__G)",
    d: "M231.358 449.357h8.502v2.221h-5.92v3.721h4.781v2.22h-4.781v3.821h6.24v2.221h-8.822z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__H",
    x1: 248.79,
    x2: 248.79,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__H)",
    d: "M247.501 451.578h-4.662v-2.221h11.902v2.221h-4.66v11.982h-2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__I",
    x1: 263.32,
    x2: 263.32,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__I)",
    d: "M258.319 449.357h5.482c2.66 0 4.52 1.86 4.52 4.621s-1.859 4.681-4.52 4.681h-2.902v4.901h-2.58zm5.002 7.061c1.5 0 2.381-.96 2.381-2.44 0-1.46-.881-2.4-2.342-2.4h-2.461v4.841h2.422z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__J",
    x1: 276.66,
    x2: 276.66,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__J)",
    d: "M272.3 449.357h2.58v11.982h6.141v2.221H272.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__K",
    x1: 289.81,
    x2: 289.81,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__K)",
    d: "M292.3 459.919h-4.98l-1.199 3.641h-2.662l5.002-14.203h2.701l5 14.203h-2.66zm-2.5-8.102s-.32 1.4-.6 2.201l-1.26 3.801h3.721l-1.262-3.801c-.26-.8-.559-2.201-.559-2.201z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__L",
    x1: 305.08,
    x2: 305.08,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__L)",
    d: "M305.919 449.117c3.461 0 5.242 1.94 5.242 1.94l-1.24 1.92s-1.621-1.5-3.881-1.5c-3 0-4.762 2.24-4.762 4.881 0 2.701 1.82 5.081 4.781 5.081 2.461 0 4.121-1.8 4.121-1.8l1.361 1.86s-1.961 2.301-5.582 2.301c-4.342 0-7.342-3.221-7.342-7.402.001-4.12 3.122-7.281 7.302-7.281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__M",
    x1: 320.029,
    x2: 320.029,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__M)",
    d: "M315.618 449.357h8.502v2.221h-5.922v3.721h4.781v2.22h-4.781v3.821h6.242v2.221h-8.822z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__N",
    x1: 339.459,
    x2: 339.459,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__N)",
    d: "M335.378 449.357h8.162v2.221h-5.582v4.021h4.701v2.221h-4.701v5.741h-2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__O",
    x1: 353.039,
    x2: 353.039,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__O)",
    d: "M347.657 449.357h4.582c1.541 0 2.24.12 2.861.4 1.42.64 2.32 2 2.32 3.88 0 1.701-.9 3.281-2.4 3.881v.04s.199.2.479.7l2.922 5.301h-2.881l-2.82-5.301h-2.48v5.301h-2.582v-14.202zm4.903 6.662c1.379 0 2.24-.82 2.24-2.241 0-1.36-.58-2.2-2.602-2.2h-1.959v4.441z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__P",
    x1: 368.799,
    x2: 368.799,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__P)",
    d: "M368.798 449.117c4.182 0 7.342 3.181 7.342 7.241 0 4.181-3.16 7.442-7.342 7.442-4.18 0-7.34-3.261-7.34-7.442 0-4.06 3.16-7.241 7.34-7.241m0 12.322c2.602 0 4.682-2.16 4.682-5.081 0-2.8-2.08-4.881-4.682-4.881-2.6 0-4.68 2.081-4.68 4.881 0 2.921 2.08 5.081 4.68 5.081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__Q",
    x1: 387.438,
    x2: 387.438,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__Q)",
    d: "M381.177 449.357h2.762l2.779 7.021c.32.84.721 2.081.721 2.081h.041s.379-1.24.699-2.081l2.781-7.021h2.76l1.141 14.203H392.3l-.6-7.942c-.061-.94-.02-2.2-.02-2.2h-.041s-.42 1.38-.76 2.2l-2.301 5.501h-2.26l-2.281-5.501c-.34-.82-.779-2.22-.779-2.22h-.041s.041 1.28-.02 2.22l-.6 7.942h-2.582z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__R",
    x1: 410.848,
    x2: 410.848,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__R)",
    d: "M413.339 459.919h-4.982l-1.199 3.641h-2.66l5-14.203h2.701l5 14.203h-2.66zm-2.502-8.102s-.318 1.4-.6 2.201l-1.26 3.801h3.721l-1.26-3.801c-.26-.8-.561-2.201-.561-2.201z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__S",
    x1: 426.098,
    x2: 426.098,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__S)",
    d: "M420.716 449.357h4.582c1.541 0 2.24.12 2.861.4 1.42.64 2.32 2 2.32 3.88 0 1.701-.9 3.281-2.4 3.881v.04s.199.2.479.7l2.922 5.301h-2.881l-2.82-5.301h-2.48v5.301h-2.582v-14.202zm4.902 6.662c1.379 0 2.24-.82 2.24-2.241 0-1.36-.58-2.2-2.602-2.2h-1.959v4.441z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__T",
    x1: 439.808,
    x2: 439.808,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__T)",
    d: "M438.517 451.578h-4.66v-2.221h11.902v2.221h-4.662v11.982h-2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__U",
    x1: 450.627,
    x2: 450.627,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__U)",
    d: "M449.337 449.357h2.58v14.203h-2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__V",
    x1: 460.927,
    x2: 460.927,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__V)",
    d: "M457.536 459.919s1.541 1.5 3.541 1.5c1.08 0 2.061-.56 2.061-1.72 0-2.541-6.701-2.101-6.701-6.461 0-2.36 2.039-4.121 4.76-4.121 2.801 0 4.242 1.52 4.242 1.52l-1.121 2.101s-1.359-1.24-3.141-1.24c-1.199 0-2.141.7-2.141 1.7 0 2.521 6.682 1.9 6.682 6.441 0 2.261-1.721 4.161-4.682 4.161-3.16 0-4.9-1.94-4.9-1.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__W",
    x1: 474.226,
    x2: 474.226,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__W)",
    d: "M472.937 451.578h-4.662v-2.221h11.902v2.221h-4.66v11.982h-2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__X",
    x1: 487.466,
    x2: 487.466,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__X)",
    d: "M484.075 459.919s1.541 1.5 3.541 1.5c1.08 0 2.061-.56 2.061-1.72 0-2.541-6.701-2.101-6.701-6.461 0-2.36 2.041-4.121 4.762-4.121 2.801 0 4.24 1.52 4.24 1.52l-1.121 2.101s-1.359-1.24-3.141-1.24c-1.199 0-2.141.7-2.141 1.7 0 2.521 6.682 1.9 6.682 6.441 0 2.261-1.719 4.161-4.68 4.161-3.162 0-4.902-1.94-4.902-1.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__Y",
    x1: 507.176,
    x2: 507.176,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__Y)",
    d: "M503.095 449.357h8.162v2.221h-5.582v4.021h4.701v2.221h-4.701v5.741h-2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__Z",
    x1: 521.737,
    x2: 521.737,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__Z)",
    d: "M521.737 449.117c4.18 0 7.342 3.181 7.342 7.241 0 4.181-3.162 7.442-7.342 7.442-4.182 0-7.342-3.261-7.342-7.442.001-4.06 3.161-7.241 7.342-7.241m0 12.322c2.6 0 4.68-2.16 4.68-5.081 0-2.8-2.08-4.881-4.68-4.881-2.602 0-4.682 2.081-4.682 4.881.001 2.921 2.081 5.081 4.682 5.081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__aa",
    x1: 538.776,
    x2: 538.776,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__aa)",
    d: "M533.396 449.357h4.58c1.541 0 2.24.12 2.861.4 1.42.64 2.32 2 2.32 3.88 0 1.701-.9 3.281-2.4 3.881v.04s.199.2.48.7l2.92 5.301h-2.881l-2.82-5.301h-2.48v5.301h-2.58zm4.9 6.662c1.381 0 2.24-.82 2.24-2.241 0-1.36-.58-2.2-2.6-2.2h-1.961v4.441z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__ab",
    x1: 560.296,
    x2: 560.296,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__ab)",
    d: "M561.136 449.117c3.461 0 5.24 1.94 5.24 1.94l-1.24 1.92s-1.619-1.5-3.881-1.5c-3 0-4.76 2.24-4.76 4.881 0 2.701 1.82 5.081 4.781 5.081 2.459 0 4.121-1.8 4.121-1.8l1.359 1.86s-1.961 2.301-5.582 2.301c-4.34 0-7.34-3.221-7.34-7.402.001-4.12 3.12-7.281 7.302-7.281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__ac",
    x1: 577.116,
    x2: 577.116,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__ac)",
    d: "M577.116 449.117c4.182 0 7.342 3.181 7.342 7.241 0 4.181-3.16 7.442-7.342 7.442s-7.342-3.261-7.342-7.442c0-4.06 3.161-7.241 7.342-7.241m0 12.322c2.6 0 4.682-2.16 4.682-5.081 0-2.8-2.082-4.881-4.682-4.881-2.602 0-4.682 2.081-4.682 4.881.001 2.921 2.081 5.081 4.682 5.081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__ad",
    x1: 595.757,
    x2: 595.757,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__ad)",
    d: "M589.495 449.357h2.76l2.781 7.021c.32.84.721 2.081.721 2.081h.039s.381-1.24.701-2.081l2.779-7.021h2.762l1.141 14.203h-2.561l-.602-7.942c-.059-.94-.02-2.2-.02-2.2h-.039s-.422 1.38-.762 2.2l-2.301 5.501h-2.26l-2.279-5.501c-.342-.82-.781-2.22-.781-2.22h-.039s.039 1.28-.021 2.22l-.6 7.942h-2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__ae",
    x1: 615.017,
    x2: 615.017,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__ae)",
    d: "M608.755 449.357h2.76l2.781 7.021c.32.84.721 2.081.721 2.081h.039s.381-1.24.701-2.081l2.779-7.021h2.762l1.141 14.203h-2.561l-.602-7.942c-.059-.94-.02-2.2-.02-2.2h-.039s-.422 1.38-.762 2.2l-2.301 5.501h-2.26l-2.279-5.501c-.342-.82-.781-2.22-.781-2.22h-.039s.039 1.28-.021 2.22l-.6 7.942h-2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__af",
    x1: 632.826,
    x2: 632.826,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__af)",
    d: "M627.095 449.357h2.58v9.102c0 1.9 1.24 2.98 3.141 2.98s3.16-1.08 3.16-3v-9.082h2.582v9.102c0 3.181-2.301 5.341-5.723 5.341-3.439 0-5.74-2.161-5.74-5.341z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__ag",
    x1: 649.455,
    x2: 649.455,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__ag)",
    d: "M643.653 449.357h2.58l5.383 8.202c.539.82 1.18 2.201 1.18 2.201h.039s-.139-1.36-.139-2.201v-8.202h2.561v14.203h-2.561l-5.383-8.182c-.539-.82-1.18-2.201-1.18-2.201h-.039s.139 1.36.139 2.201v8.182h-2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__ah",
    x1: 661.844,
    x2: 661.844,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__ah)",
    d: "M660.554 449.357h2.58v14.203h-2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__ai",
    x1: 672.665,
    x2: 672.665,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__ai)",
    d: "M671.374 451.578h-4.66v-2.221h11.902v2.221h-4.662v11.982h-2.58z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__aj",
    x1: 683.483,
    x2: 683.483,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__aj)",
    d: "M682.192 449.357h2.582v14.203h-2.582z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__ak",
    x1: 694.484,
    x2: 694.484,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__ak)",
    d: "M690.073 449.357h8.502v2.221h-5.922v3.721h4.781v2.22h-4.781v3.821h6.242v2.221h-8.822z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-v_svg__al",
    x1: 706.983,
    x2: 706.983,
    y1: 447.234,
    y2: 474.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a7a9ac"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-v_svg__al)",
    d: "M703.593 459.919s1.541 1.5 3.541 1.5c1.08 0 2.061-.56 2.061-1.72 0-2.541-6.701-2.101-6.701-6.461 0-2.36 2.039-4.121 4.76-4.121 2.801 0 4.242 1.52 4.242 1.52l-1.121 2.101s-1.359-1.24-3.141-1.24c-1.199 0-2.141.7-2.141 1.7 0 2.521 6.682 1.9 6.682 6.441 0 2.261-1.721 4.161-4.682 4.161-3.16 0-4.9-1.94-4.9-1.94z"
  })));
};
export default SvgLogoV;